<template>
	<div class="">
		<!--<div class="sc-iCfMLu bCMwMe" style="min-width: 1280px;">
			<div dir="ltr" role="row" class="next-row sc-furwcr gxfVWI">
				<div dir="ltr" role="gridcell" class="next-col next-col-12 sc-pVTFL bAkHdY">
					<a class="logo-link">
						<img src="/img/logo.82b9c7a5.png" alt="" class="logo-image">
					</a>
					<span class="logo-text">登录</span>
				</div>
			</div>
		</div>-->
		<div class="zxj_login" :style="{backgroundImage:`url(${basicInfo.explode_pic})`}">
			<div class="slideverify" v-show="isShowSlide">
				<SlideVerify ref="slideblock" @success="sendSmsCode" @close="close_slideverify"></SlideVerify>
			</div>
			<div class="zxj_login__view">
				<!--<p class="zxj_login__viewP">登录</p>-->
				<el-tabs v-model="activeName" @tab-click="handleClick" style="margin: 50px">
					<el-tab-pane label="账号登录" name="first"></el-tab-pane>
					<el-tab-pane label="验证码登录" name="second"></el-tab-pane>
				</el-tabs>
				<div v-if="!display">
					<div class="zxj_login__viewInput">
						<el-input v-model="phone" placeholder="请输入手机号" :readonly='readonly' @focus='handlerIptClick'
							autocomplete='off'>
						</el-input>
					</div>
					<div class="zxj_login__viewInput">
						<el-input v-model="password" placeholder="请输入密码,首次登录请使用验证码登录" :readonly='readonly'
							@focus='handlerIptClick' autocomplete='off' type="password">
						</el-input>
					</div>
				</div>
				<div v-if="display">
					<div class="zxj_login__viewInput">
						<el-input v-model="phone" placeholder="请输入手机号"></el-input>
					</div>
					<div class="zxj_login__viewInput">
						<div style="display: flex">
							<el-input v-model="phoneCode" placeholder="验证码" show-word-limit class="input_width">
							</el-input>
							<el-button plain v-bind:type="button_sms_type" v-on:click="sendSmsCode2"
								v-bind:disabled="button_sms_disable" style="margin-left: 5px">{{button_sms_value}}
							</el-button>
						</div>
					</div>
				</div>
				<div class="">
					<el-button class="zxj_login__viewBtn" @click="submitForm">登录</el-button>
					<div class="zxj_login__register">
						<p>没有账号，去<span class="login_colorP" @click="$router.push('/register')">注册</span></p>
						<p class="login_colorP" @click="$router.push('/forgetpassword')">忘记密码</p>
					</div>
					<!--<div style="text-align: center;font-size: 12px;color: grey">首次登录，请使用验证码登录</div>-->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		Login,
		sendSms,
		getBasicInfo
	} from "../../api/moudles/user";
	import SlideVerify from "./components/SliderVerify"; //引入

	export default {
		components: {
			SlideVerify, //注册组件
		},
		data() {
			return {
				basicInfo: {},
				phone: '',
				isShowSlide: false,
				password: '',
				phoneCode: '',
				activeName: 'first',
				button_sms_type: 'success',
				button_sms_value: '发送验证码',
				button_sms_disable: false,
				readonly: true,
				display: false,
				sms_time_count: 120,
				sms_timer: null,
			}
		},
		created() {
			this.getBasicInfo()
		},
		methods: {
			// 获取基本信息
			async getBasicInfo() {
				await getBasicInfo({
					data: {
						column_code: '5F8B3D07-841C-E204-58D9-3FF4BCEE4765'
					},
					success: res => {
						// console.log('res网校', res.data)
						this.basicInfo = res.data
					}
				})
			},
			handlerIptClick() {
				this.readonly = false;
			},
			close_slideverify() {
				this.isShowSlide = false
			},
			hideSlide() {
				setTimeout(() => {
					this.isShowSlide = false;
				}, 500);
			},
			sendSmsCode2() {
				if (this.phone === '') {
					this.$message({
						message: '发送手机号不能为空',
						type: 'warning'
					});
					return
				}
				let mobile_mode = /^1[3456789]\d{9}$/;
				if (!mobile_mode.test(this.phone)) {
					this.$message({
						message: '手机号码格式错误',
						type: 'warning'
					});
					return
				}
				setTimeout(() => {
					this.isShowSlide = true;
				}, 500);
			},
			handleClick(tab, event) {
				console.log(tab, event);
				if (tab.index == 1) {
					this.display = true
				} else {
					this.display = false
				}
			},
			async sendSmsCode() {
				// 手机号为空，警告提示
				if (this.phone === '') {
					this.$message({
						message: '发送手机号不能为空',
						type: 'warning'
					});
					return
				}
				let mobile_mode = /^1[3456789]\d{9}$/;
				if (!mobile_mode.test(this.phone)) {
					this.$message({
						message: '手机号码错误',
						type: 'warning'
					});
					return
				}
				// 发送本地springboot请求,本机的地址：192.168.3.12
				await sendSms({
					data: {
						phone: this.phone
					},
					success: (res) => {
						this.isShowSlide = false;
						// console.log(res)
						if (res.code == 200) {
							this.$message({
								message: '成功发送验证码',
								type: 'success'
							})
							this.sms_count_down()
						} else {
							this.$message.error(res.msg);
						}
					}
				})
			},
			sms_count_down() {
				// 验证码倒计时
				if (!this.sms_timer) {
					this.count = this.sms_time_count
					//验证码发送成功，倒计时
					this.button_sms_type = 'info'
					this.button_sms_disable = true
					this.button_sms_value = "已发送(" + this.count + ")"

					//第一种缩写写法
					this.sms_timer = setInterval(() => {
						if (this.count > 0 && this.count <= this.sms_time_count) {
							this.count--
							this.button_sms_value = "已发送(" + this.count + ")"
							// console.log(this.count)
						} else {
							clearInterval(this.sms_timer)
							this.sms_timer = null
							// console.log('倒计时结束')
							this.button_sms_type = 'success'
							this.button_sms_disable = false
							this.button_sms_value = '发送验证码'
						}
					}, 1000)
				}
			},

			async submitForm() {
				if (this.display == false) {
					if (this.phone == '' || this.password == '') {
						this.$message.error('不能为空哦');
						return false
					}
				} else {
					if (this.phone == '' || this.phoneCode == '') {
						this.$message.error('不能为空哦');
						return false
					}
				}

				let that = this
				Login({
					data: {
						phone: this.phone,
						password: this.password,
						phoneCode: this.phoneCode,
						loginType: this.display == false ? 'pwd' : 'yzm',
					},
					success: (res) => {
						// console.log(res)
						if (res.code != 200) {
							this.$message.error(res.msg);
						} else {
							localStorage.setItem('userToken', res.data.token)
							localStorage.setItem('userName', res.data.username)
							localStorage.setItem('userAvatar', res.data.userAvatar)
							if (res.data.resetPwd != undefined && res.data.resetPwd == 1) {
								setTimeout(function() {
									that.$router.push({
										path: '/setpwd',
										query: {}
									})
								}, 500)
							} else {
								that.$message.success('登录成功');
								that.$bus.$emit('brotherEvent', 'login')
								if (this.$route.query.redirect == location.hostname) {
									that.$router.go(-1);
								} else {
									setTimeout(function() {
										that.$router.push({
											path: '/userinfo',
											query: {}
										})
									}, 500)
								}
							}
						}
					}
				})
			},
		}
	}
</script>

<style scoped>
	.slideverify {
		position: fixed;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		background: rgba(0, 0, 0, .4);
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 7;
	}

	.zjxLogin {
		min-height: 710px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.zxj_login {
		height: calc(100vh - 160px);
		background-color: #fff;
		display: flex;
		align-items: center;
		justify-content: center;
		background-size: cover;
	}

	.zxj_login__view {
		margin-right: 50px;
		width: 450px;
		height: 450px;
		border: 1px solid antiquewhite;
		display: flex;
		flex-flow: column;
		align-items: center;
		margin-left: 34%;
		background-color: rgb(255, 255, 255)
	}

	.zxj_login__viewP {
		width: 452px;
		margin: 30px 0;

		font-size: 20px;
		display: inline-block;
		height: 50px;
		text-align: center;
		line-height: 50px;
		font-weight: 600;
	}

	.zxj_login__viewInput {
		margin-bottom: 40px;
		width: 300px;
		height: 40px;

	}

	.zxj_login__viewBtn {
		width: 300px;
		height: 40px;
		background-color: #66b1ff;
		color: #fff;
	}

	.zxj_login__register {
		margin: 10px 0;
		display: flex;
		justify-content: space-between;
		font-size: 14px;
	}

	.login_colorP {
		color: #66b1ff;
		cursor: pointer;
	}

	/**滚动条的宽度*/
	::-webkit-scrollbar {
		width: 5px;
		height: 5px;
	}

	/*滚动条的滑块*/
	::-webkit-scrollbar-thumb {
		background-color: rgb(185, 221, 255);
		border-radius: 5px;
	}

	::-webkit-scrollbar-thumb:hover {
		background: rgba(24, 144, 255, .8);
	}

	.bCMwMe {
		background: rgb(255, 255, 255);
		box-shadow: rgb(0 0 0 / 10%) 0px 2px 4px 0px;
		box-sizing: border-box;
		height: 60px;
	}


	.gxfVWI {
		padding: 20px 24px;
		height: 100%;
		margin: 0px auto;
		-webkit-box-align: center;
		align-items: center;
	}

	.bAkHdY {
		display: flex;
	}

	.next-col-12 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 50%;
		flex: 0 0 50%;
		max-width: 50%;
		width: 50%;
	}

	.bAkHdY .logo-link {
		display: flex;
		-webkit-box-align: center;
		align-items: center;
	}

	.bAkHdY .logo-text {
		font-size: 18px;
		color: rgb(24, 24, 24);
		display: inline-block;
		padding: 0px 10px;
	}

	.NQuwj {
		display: flex;
		-webkit-box-pack: end;
		justify-content: flex-end;
	}

	.next-col-12 {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 50%;
		flex: 0 0 50%;
		max-width: 50%;
		width: 50%;
	}

	.bAkHdY .logo-link {
		display: flex;
		-webkit-box-align: center;
		align-items: center;
	}

	.bAkHdY .logo-image {
		height: 21px;
		padding-right: 10px;
	}

	.slide-verify {
		margin-left: 122%;
		z-index: 1999;
	}
</style>
